import type { AppConfigJSON as AppConfig } from "@bingo/contract-fan-api";
import { useMemo } from "react";

export type { AppConfig };

/**
 * This returns the injected app config (set at `window.__APP_CONFIG`).
 *
 * If the injected config is not found, this will throw an error.
 */
export function useAppConfig(): AppConfig {
  const config = useMemo(() => {
    const injected = getInjectedConfig();

    if (!injected) {
      throw new Error("No injected config found");
    }

    return injected;
  }, []);

  return config;
}

function getInjectedConfig() {
  const KEY = "__APP_CONFIG";
  return (window as unknown as { [KEY]: AppConfig | null })[KEY];
}
